import { gql } from '@apollo/client';

export const GET_PROPOSAL_REVISIONS = gql`
  query GET_PROPOSAL_REVISIONS(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
  ) {
    proposalRevisions(ids: $ids, projectIds: $projectIds, status: $status) {
      id
      date
      #   revisedProposal {
      #   id
      #   filename
      # }
      # supportingDocuments {
      #   id
      #   filename
      # }
      highlights
      justification
      status
    }
  }
`;

export const GET_PROPOSAL_REVISION = gql`
  query GET_PROPOSAL_REVISION(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
  ) {
    proposalRevisions(ids: $ids, projectIds: $projectIds, status: $status) {
      id
      date
      revisedProposal {
        id
        filename
      }
      supportingDocuments {
        id
        filename
      }
      changesIncluded
      highlights
      justification
      status
      approvalRoute {
        sequence
        appointedApprover {
          role {
            id
            name
          }
          faculty {
            id
            name
          }
          department {
            id
            name
          }
        }
        approvalSteps {
          sequence
          name
          approverListingType
          appointedApprover {
            role {
              id
              name
            }
            faculty {
              id
              name
            }
            department {
              id
              name
            }
          }
          approver {
            id
            netId
            name
          }
          approved
          comment
          date
        }
      }
    }
  }
`;

export const ADD_PROPOSAL_REVISION = gql`
  mutation ADD_PROPOSAL_REVISION($input: AddProposalRevisionInput!) {
    addProposalRevision(input: $input) {
      id
    }
  }
`;

export const UPDATE_PROPOSAL_REVISION = gql`
  mutation UPDATE_PROPOSAL_REVISION($input: UpdateProposalRevisionInput!) {
    updateProposalRevision(input: $input) {
      id
    }
  }
`;

export const SUBMIT_PROPOSAL_REVISION = gql`
  mutation SUBMIT_PROPOSAL_REVISION($input: SubmitProposalRevisionInput!) {
    submitProposalRevision(input: $input) {
      id
    }
  }
`;

export const SUBMIT_PROPOSAL_REVISION_WITH_CUSTOM_DATE = gql`
  mutation SUBMIT_PROPOSAL_REVISION_WITH_CUSTOM_DATE(
    $input: SubmitProposalRevisionWithCustomDateInput!
  ) {
    submitProposalRevisionWithCustomDate(input: $input) {
      id
    }
  }
`;

export const CANCEL_PROPOSAL_REVISION = gql`
  mutation CANCEL_PROPOSAL_REVISION($input: CancelProposalRevisionInput!) {
    cancelProposalRevision(input: $input) {
      id
      status
    }
  }
`;

export const DELETE_PROPOSAL_REVISION = gql`
  mutation DELETE_PROPOSAL_REVISION($input: DeleteProposalRevisionInput!) {
    deleteProposalRevision(input: $input) {
      id
      status
    }
  }
`;

export const APPROVE_PROPOSAL_REVISION = gql`
  mutation APPROVE_PROPOSAL_REVISION($input: ApproveProposalRevisionInput!) {
    approveProposalRevision(input: $input) {
      id
      status
    }
  }
`;

export const VOID_PROPOSAL_REVISION = gql`
  mutation VOID_PROPOSAL_REVISION($input: VoidProposalRevisionInput!) {
    voidProposalRevision(input: $input) {
      id
      status
    }
  }
`;
